import React from 'react';
import './index.scss';
interface DelayTimeRecordProps {
  delayList: {
    desc: string;
    value: number;
    mark?: string;
  }[];
}

const DelayTimeRecord = (props: DelayTimeRecordProps) => {
  const { delayList } = props;
  return (
    <div className='delay-record-wrapper'>
      <div className='delay-record-list'>
        {delayList.map((item, index) => {
          return (
            <div key={index} className='delay-item'>
              <i className='delay-value'>
                {item.value === -1 ? '--' : item.value}
              </i>
              <i className='delay-desc'>{item.desc}</i>
              {item.mark && <i className='mark-label'>{item.mark}</i>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(DelayTimeRecord);
